
(function () {
  var API = 'https://api.judge.me/reviews/reviews_for_widget';
  var MOBILE = window.matchMedia('(max-width: 991px)');
  var STAR = 'M12 2.5l2.94 6.1 6.56.8-4.84 4.56 1.24 6.54L12 17.3l-5.9 3.2 1.24-6.54L2.5 9.4l6.56-.8z';
  var CLOSE_ICON = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';
  var PAGE_SIZE = 10;
  var SORTS = [
    { value: 'created_at:desc', label: 'Most recent' },
    { value: 'rating:desc', label: 'Highest rated' },
    { value: 'rating:asc', label: 'Lowest rated' },
    { value: 'pictures_first:desc', label: 'With photos first' }
  ];

  /* ---------- helpers ---------- */

  function el(tag, cls, content) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (content != null) node.textContent = content;
    return node;
  }

  function plainText(html) {
    if (!html) return '';
    var withBreaks = String(html).replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>\s*<p[^>]*>/gi, '\n\n');
    var doc = new DOMParser().parseFromString(withBreaks, 'text/html');
    return (doc.body.textContent || '').replace(/[ \t]+/g, ' ').replace(/\n{3,}/g, '\n\n').trim();
  }

  function formatDate(value) {
    if (!value) return '';
    var d = new Date(String(value).replace(' UTC', 'Z').replace(' ', 'T'));
    if (isNaN(d)) return '';
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }

  function starsSvg(score) {
    var svg = '';
    for (var i = 1; i <= 5; i++) {
      svg += '<svg viewBox="0 0 24 24" aria-hidden="true" class="' + (i <= Math.round(score) ? 'is-on' : 'is-off') + '"><path d="' + STAR + '"/></svg>';
    }
    return svg;
  }

  function stars(score, withNumber) {
    var wrap = el('span', 'falcon-reviews__stars');
    wrap.setAttribute('role', 'img');
    wrap.setAttribute('aria-label', score + ' out of 5 stars');
    wrap.innerHTML = starsSvg(score);
    if (withNumber) wrap.appendChild(el('span', 'falcon-reviews__score-num', String(score)));
    return wrap;
  }

  function pictureUrls(review) {
    return (review.pictures_urls || []).map(function (p) {
      return { thumb: p.compact || p.small || p.original, full: p.huge || p.original || p.compact };
    }).filter(function (p) { return p.thumb; });
  }

  function fetchReviews(cfg, opts) {
    var sort = (opts.sort || SORTS[0].value).split(':');
    var params = [
      'url=' + encodeURIComponent(cfg.shop),
      'shop_domain=' + encodeURIComponent(cfg.shop),
      'platform=shopify',
      'product_id=' + encodeURIComponent(cfg.productId),
      'page=' + (opts.page || 1),
      'per_page=' + (opts.perPage || PAGE_SIZE),
      'sort_by=' + sort[0],
      'sort_dir=' + sort[1]
    ];
    if (opts.rating) params.push('filter_rating=' + opts.rating);
    return fetch(API + '?' + params.join('&')).then(function (res) {
      if (!res.ok) throw new Error('Judge.me ' + res.status);
      return res.json();
    });
  }

  /* ---------- one review row (used inline and in the popup) ---------- */

  function renderItem(r, full, onPhoto) {
    var item = el('article', 'falcon-reviews__item');
    var head = el('div', 'falcon-reviews__head');
    head.appendChild(stars(r.rating, true));
    var who = el('div', 'falcon-reviews__who');
    who.appendChild(el('span', 'falcon-reviews__author', r.reviewer_name || 'Verified buyer'));
    if (full && r.verified_buyer) {
      var v = el('span', 'fpr-modal__verified');
      v.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
      v.appendChild(document.createTextNode('Verified'));
      who.appendChild(v);
    }
    var date = formatDate(r.created_at);
    if (date) {
      who.appendChild(el('span', 'falcon-reviews__sep'));
      who.appendChild(el('span', '', date));
    }
    head.appendChild(who);
    item.appendChild(head);

    if (r.title) item.appendChild(el('p', 'falcon-reviews__rtitle', r.title));
    var body = plainText(r.body_html);
    if (body) item.appendChild(el('p', 'falcon-reviews__body', body));

    var allPics = pictureUrls(r);
    var fullUrls = allPics.map(function (p) { return p.full; });
    var pics = allPics.slice(0, full ? 6 : 3);
    if (pics.length) {
      var row = el('div', 'falcon-reviews__pics');
      pics.forEach(function (p, i) {
        var b = el('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Enlarge photo from ' + (r.reviewer_name || 'buyer'));
        var img = el('img');
        img.src = p.thumb;
        img.alt = '';
        img.loading = 'lazy';
        b.appendChild(img);
        b.addEventListener('click', function () { onPhoto(fullUrls, i); });
        row.appendChild(b);
      });
      item.appendChild(row);
    }

    if (full && r.reply_content) {
      var reply = el('div', 'fpr-modal__reply');
      reply.appendChild(el('strong', '', 'Response from ' + (r.shop_reply_name || 'the shop')));
      reply.appendChild(document.createTextNode(plainText(r.reply_content)));
      item.appendChild(reply);
    }
    return item;
  }

  /* ---------- popup ---------- */

  function Modal(cfg) {
    this.cfg = cfg;
    this.state = { sort: SORTS[0].value, rating: 0, photos: false, page: 0, totalPages: 1, loading: false };
    this.build();
  }

  Modal.prototype.build = function () {
    var self = this;
    var m = el('div', 'fpr-modal');
    m.hidden = true;
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    m.setAttribute('aria-labelledby', 'FprModalTitle');
    m.innerHTML =
      '<div class="fpr-modal__backdrop" data-close></div>' +
      '<div class="fpr-modal__panel">' +
        '<div class="fpr-modal__head">' +
          '<h2 class="fpr-modal__title" id="FprModalTitle">Reviews for this item <span data-count></span></h2>' +
          '<button type="button" class="fpr-modal__close" aria-label="Close reviews" data-close>' + CLOSE_ICON + '</button>' +
        '</div>' +
        '<div class="fpr-modal__body">' +
          '<div class="fpr-modal__overview">' +
            '<div class="fpr-modal__score"><span class="fpr-modal__score-num" data-avg></span><span data-avg-stars></span><span class="fpr-modal__score-count" data-count-text></span></div>' +
            '<div class="fpr-modal__bars" data-bars></div>' +
          '</div>' +
          '<div class="fpr-modal__photos" data-photos hidden><p class="fpr-modal__section-label">Photos from reviews</p><div class="fpr-modal__photo-row" data-photo-row></div></div>' +
          '<div class="fpr-modal__toolbar">' +
            '<div class="fpr-modal__chips" data-chips></div>' +
            '<select class="fpr-modal__sort" aria-label="Sort reviews" data-sort></select>' +
          '</div>' +
          '<div class="fpr-modal__list" data-list></div>' +
          '<div class="fpr-modal__footer" data-footer hidden><button type="button" class="falcon-reviews__more" data-more>Load more reviews</button></div>' +
        '</div>' +
        '<div class="fpr-lightbox" data-lightbox hidden>' +
          '<button type="button" class="fpr-modal__close" aria-label="Close photo" data-lb-close>' + CLOSE_ICON + '</button>' +
          '<button type="button" class="fpr-lightbox__nav fpr-lightbox__nav--prev" aria-label="Previous photo" data-lb-prev><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg></button>' +
          '<img alt="">' +
          '<button type="button" class="fpr-lightbox__nav fpr-lightbox__nav--next" aria-label="Next photo" data-lb-next><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg></button>' +
          '<span class="fpr-lightbox__count" data-lb-count aria-live="polite"></span>' +
        '</div>' +
      '</div>';
    document.body.appendChild(m);
    this.root = m;
    this.q = function (sel) { return m.querySelector(sel); };

    var sort = this.q('[data-sort]');
    SORTS.forEach(function (s) {
      var o = el('option', '', s.label);
      o.value = s.value;
      sort.appendChild(o);
    });
    sort.addEventListener('change', function () {
      self.state.sort = sort.value;
      self.reload();
    });

    m.querySelectorAll('[data-close]').forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
    this.q('[data-more]').addEventListener('click', function () { self.loadPage(); });
    var lb = this.q('[data-lightbox]');
    /* Clicking the dark area or × closes; the photo and arrows don't. */
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.closest('[data-lb-close]')) lb.hidden = true;
    });
    this.q('[data-lb-prev]').addEventListener('click', function () { self.stepPhoto(-1); });
    this.q('[data-lb-next]').addEventListener('click', function () { self.stepPhoto(1); });

    var touchX = null;
    lb.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) > 40) self.stepPhoto(dx < 0 ? 1 : -1);
    });

    document.addEventListener('keydown', function (e) {
      if (m.hidden) return;
      if (!lb.hidden && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
        e.preventDefault();
        self.stepPhoto(e.key === 'ArrowRight' ? 1 : -1);
        return;
      }
      if (e.key !== 'Escape') return;
      if (!lb.hidden) lb.hidden = true;
      else self.close();
    });
  };

  /* Opens the photo viewer on photos[index]; arrows / swipe / keys move through the set. */
  Modal.prototype.showPhoto = function (photos, index) {
    this.photos = [].concat(photos);
    this.photoIndex = index || 0;
    var lb = this.q('[data-lightbox]');
    var multi = this.photos.length > 1;
    this.q('[data-lb-prev]').hidden = !multi;
    this.q('[data-lb-next]').hidden = !multi;
    this.q('[data-lb-count]').hidden = !multi;
    this.renderPhoto();
    lb.hidden = false;
    lb.querySelector(multi ? '[data-lb-next]' : '[data-lb-close]').focus();
  };

  Modal.prototype.stepPhoto = function (dir) {
    if (!this.photos || this.photos.length < 2) return;
    var n = this.photos.length;
    this.photoIndex = (this.photoIndex + dir + n) % n;
    this.renderPhoto();
  };

  Modal.prototype.renderPhoto = function () {
    this.q('[data-lightbox] img').src = this.photos[this.photoIndex];
    this.q('[data-lb-count]').textContent = (this.photoIndex + 1) + ' / ' + this.photos.length;
    var next = this.photos[(this.photoIndex + 1) % this.photos.length];
    if (next) (new Image()).src = next;
  };

  Modal.prototype.setSummary = function (data) {
    var self = this;
    var total = data.number_of_reviews || 0;
    var avg = parseFloat(data.average_rating) || 0;
    this.q('[data-count]').textContent = '(' + total + ')';
    this.q('[data-avg]').textContent = avg.toFixed(1);
    this.q('[data-avg-stars]').innerHTML = '';
    this.q('[data-avg-stars]').appendChild(stars(avg, false));
    this.q('[data-count-text]').textContent = total + ' reviews';

    var bars = this.q('[data-bars]');
    bars.innerHTML = '';
    (data.histogram || []).slice().sort(function (a, b) { return b.rating - a.rating; }).forEach(function (h) {
      var b = el('button', 'fpr-modal__bar');
      b.type = 'button';
      b.dataset.rating = h.rating;
      b.disabled = !h.frequency;
      b.setAttribute('aria-label', 'Show ' + h.rating + ' star reviews (' + h.frequency + ')');
      b.appendChild(el('span', '', h.rating + ' star'));
      var track = el('span', 'fpr-modal__bar-track');
      var fill = el('span', 'fpr-modal__bar-fill');
      fill.style.width = (h.percentage || 0) + '%';
      track.appendChild(fill);
      b.appendChild(track);
      b.appendChild(el('span', 'fpr-modal__bar-num', String(h.frequency)));
      b.addEventListener('click', function () { self.setRating(self.state.rating === h.rating ? 0 : h.rating); });
      bars.appendChild(b);
    });

    var gallery = (data.photo_gallery || []).reduce(function (all, r) { return all.concat(pictureUrls(r)); }, []);
    var row = this.q('[data-photo-row]');
    row.innerHTML = '';
    var stripPhotos = gallery.slice(0, 20);
    var stripUrls = stripPhotos.map(function (p) { return p.full; });
    stripPhotos.forEach(function (p, i) {
      var b = el('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Enlarge review photo');
      var img = el('img');
      img.src = p.thumb;
      img.alt = '';
      img.loading = 'lazy';
      b.appendChild(img);
      b.addEventListener('click', function () { self.showPhoto(stripUrls, i); });
      row.appendChild(b);
    });
    this.q('[data-photos]').hidden = !gallery.length;
    this.hasPhotos = gallery.length > 0;
    this.renderChips();
  };

  Modal.prototype.renderChips = function () {
    var self = this;
    var chips = this.q('[data-chips]');
    chips.innerHTML = '';
    var list = [{ key: 'all', label: 'All reviews' }];
    if (this.hasPhotos) list.push({ key: 'photos', label: 'With photos' });
    if (this.state.rating) list.push({ key: 'rating', label: this.state.rating + (this.state.rating === 1 ? ' star' : ' stars') + ' ×' });
    list.forEach(function (c) {
      var b = el('button', 'fpr-modal__chip', c.label);
      b.type = 'button';
      var active = (c.key === 'all' && !self.state.rating && !self.state.photos) ||
        (c.key === 'photos' && self.state.photos) || c.key === 'rating';
      if (active) b.classList.add('is-active');
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
      b.addEventListener('click', function () {
        if (c.key === 'all') { self.state.photos = false; self.setRating(0); }
        else if (c.key === 'photos') { self.state.photos = !self.state.photos; self.reload(); }
        else self.setRating(0);
      });
      chips.appendChild(b);
    });
    this.root.querySelectorAll('.fpr-modal__bar').forEach(function (b) {
      b.classList.toggle('is-active', Number(b.dataset.rating) === self.state.rating);
    });
  };

  Modal.prototype.setRating = function (rating) {
    this.state.rating = rating;
    this.reload();
  };

  Modal.prototype.reload = function () {
    this.state.page = 0;
    this.state.totalPages = 1;
    this.token = (this.token || 0) + 1;
    this.q('[data-list]').innerHTML = '';
    this.renderChips();
    this.loadPage();
  };

  /* "With photos" is not an API filter, so photo-less reviews are skipped client side and
     pages keep loading until enough photo reviews are found (they're sorted first). */
  Modal.prototype.loadPage = function () {
    var self = this;
    var s = this.state;
    if (s.loading || s.page >= s.totalPages) return;
    s.loading = true;
    var token = this.token;
    var list = this.q('[data-list]');
    var footer = this.q('[data-footer]');
    var status = el('p', 'fpr-modal__status', 'Loading reviews…');
    list.appendChild(status);
    footer.hidden = true;

    fetchReviews(this.cfg, {
      page: s.page + 1,
      sort: s.photos ? 'pictures_first:desc' : s.sort,
      rating: s.rating
    }).then(function (data) {
      if (token !== self.token) return;
      status.remove();
      if (!self.summaryReady) { self.setSummary(data); self.summaryReady = true; }
      s.page = (data.pagination && data.pagination.current_page) || s.page + 1;
      s.totalPages = (data.pagination && data.pagination.total_pages) || s.page;
      var reviews = data.reviews || [];
      if (s.photos) {
        var before = reviews.length;
        reviews = reviews.filter(function (r) { return pictureUrls(r).length; });
        if (reviews.length < before) s.totalPages = s.page;
      }
      reviews.forEach(function (r) {
        list.appendChild(renderItem(r, true, function (photos, i) { self.showPhoto(photos, i); }));
      });
      if (!list.children.length) list.appendChild(el('p', 'fpr-modal__status', 'No reviews match this filter yet.'));
      footer.hidden = s.page >= s.totalPages;
    }).catch(function () {
      if (token !== self.token) return;
      status.textContent = 'Reviews could not be loaded. Please try again.';
      s.page = Math.max(0, s.page);
      footer.hidden = false;
    }).then(function () {
      if (token === self.token) s.loading = false;
    });
  };

  Modal.prototype.open = function (opener) {
    this.opener = opener;
    this.root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    this.root.querySelector('.fpr-modal__head .fpr-modal__close').focus();
    if (!this.started) {
      this.started = true;
      this.reload();
    }
  };

  Modal.prototype.close = function () {
    this.root.hidden = true;
    this.q('[data-lightbox]').hidden = true;
    document.documentElement.style.overflow = '';
    if (this.opener) this.opener.focus();
  };

  /* ---------- inline block ---------- */

  /* On mobile the media column sits above the buy form, so park the block below the grid. */
  function place(root) {
    if (!root._home) {
      root._home = root.parentNode;
      root._anchor = root.nextSibling;
    }
    var grid = root._home.closest('.falcon-grid');
    if (MOBILE.matches && grid) {
      if (root.previousElementSibling !== grid) grid.parentNode.insertBefore(root, grid.nextSibling);
    } else if (root.parentNode !== root._home) {
      root._home.insertBefore(root, root._anchor && root._anchor.parentNode === root._home ? root._anchor : null);
    }
  }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    var cfg = { shop: root.dataset.shop || (window.Shopify && window.Shopify.shop), productId: root.dataset.productId };
    if (!cfg.shop || !cfg.productId || !window.fetch) return;

    var grid = root.closest('.falcon-grid');
    place(root);
    var onChange = function () { place(root); };
    if (MOBILE.addEventListener) MOBILE.addEventListener('change', onChange);
    else if (MOBILE.addListener) MOBILE.addListener(onChange);

    var modal;
    function openModal(e) {
      if (e) e.preventDefault();
      modal = modal || new Modal(cfg);
      modal.open(e && e.currentTarget);
    }
    root.querySelectorAll('[data-fpr-open]').forEach(function (b) { b.addEventListener('click', openModal); });

    /* Judge.me's star badge under the title normally jumps to its own (now hidden) widget. */
    document.addEventListener('click', function (e) {
      var badge = e.target.closest && e.target.closest('.jdgm-prev-badge, .jdgm-widget.jdgm-preview-badge');
      if (!badge || root.hidden || !grid || !grid.contains(badge)) return;
      e.preventDefault();
      e.stopPropagation();
      openModal({ preventDefault: function () {}, currentTarget: badge });
    }, true);

    var step = parseInt(root.dataset.step, 10) || 3;
    fetchReviews(cfg, { page: 1, perPage: step }).then(function (data) {
      var reviews = data.reviews || [];
      var total = data.number_of_reviews || 0;
      if (!reviews.length) return;
      root.querySelector('[data-fpr-avg]').textContent = (parseFloat(data.average_rating) || 0).toFixed(1);
      root.querySelectorAll('[data-fpr-count], [data-fpr-count-all]').forEach(function (n) { n.textContent = total; });
      var list = root.querySelector('[data-fpr-list]');
      list.innerHTML = '';
      reviews.forEach(function (r) {
        list.appendChild(renderItem(r, false, function (photos, i) {
          modal = modal || new Modal(cfg);
          modal.open(null);
          modal.showPhoto(photos, i);
        }));
      });
      root.hidden = false;
    }).catch(function () {});
  }

  function run() {
    document.querySelectorAll('[data-falcon-reviews]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
